<template>
  <nav class="rui-navbar" :class="componentCSS">
    <div v-if="$slots.left" class="rui-navbar__menu">
      <slot name="left" />
    </div>
    <div v-if="caption" class="rui-navbar__title-wrapper">
      <rui-button v-if="backCaption && backTo"
                  class="rui-navbar__title-wrapper__action"
                  icon="rui:caret-left"
                  :to="backTo"
                  :caption="backCaption"
                  no-text-on-small />
      <div class="rui-navbar__title-wrapper__content">{{ caption }}</div>
    </div>

    <div v-if="$slots.right" class="rui-navbar__menu" :class="!caption ? '-flex--grow -justify-content-end' : ''">
      <slot name="right" />
    </div>
  </nav>
</template>

<script>
import RuiButton from '../Button/Button.vue'

/**
 * Main navigation at the top of the page. Contains links on the left, right and a title in the middle.
 *
 * @preset Default {
 *                   "props": { "caption": "Page title", "backTo": "/", "backCaption": "Back" },
 *                   "slots": {
 *                     "left": "<a class=\"rui-menu-item\">Link #1</a>\n<a class=\"rui-menu-item\">Link #2</a>",
 *                     "right": "<a class=\"rui-menu-item\">Link #3</a>\n<button class=\"rui-button rui-menu-item\">Button</button>"
 *                   }
 *                 }
 * @propsGroup Display [shadowed, sticky]
 * @propsGroup Content [caption, backTo, backCaption]
 */
export default {
  name: 'RuiNavbar',
  components: { RuiButton },
  props: {
    /** Page title. If not set, the "back" link won't be visible. */
    caption: { required: false, type: String, default: null },
    /** URL for the "back" button. It may be a string or a vue-router object. */
    backTo: { required: false, type: [Object, String], default: null },
    /** Caption for the "back" button. */
    backCaption: { required: false, type: String, default: null },
    /** Adds a small shadow below the bar */
    shadowed: { required: false, type: Boolean, default: false },
    /** Makes the navbar stick at the top of its parent */
    sticky: { required: false, type: Boolean, default: false },
  },
  computed: {
    componentCSS () {
      return [
        this.shadowed && 'rui-navbar--shadowed',
        this.sticky && 'rui-navbar--sticky',
      ]
    },
  },
}
</script>
